import { PropsWithChildren } from "react";
import classes from "./Backdrop.module.scss";
import { useBodyLock } from "@/common/hooks/useBodyLock";

export const Backdrop = ({ children }: PropsWithChildren) => {
  useBodyLock(true);

  return (
    <div className={classes.Backdrop}>{children}</div>
  );
};
